"use client";

import { CarouselContentVisible, CarouselItem } from "~/components/ui/carousel";
import Answer, { AnswerItem, AnswerVideoEvents } from "~/componentsDS/Answer";
import Carousel from "~/componentsDS/Carousel";
import { useAnswerCarouselState } from "~/hooks/useAnswerCarouselState";
import type { GtmEvent } from "~/lib/gtm/getGtmEventData";
import { cn } from "~/lib/utils";

type Variant = "default" | "treatment";

type Props = {
    answerItems: AnswerItem[];
    className?: string;
    eventDataOnExpand?: Omit<GtmEvent["value"], "meta_data">;
    variant?: Variant;
    videoEvents?: AnswerVideoEvents;
    widget?: string;
};

const cardClasses: Record<Variant, string> = {
    default: "flex-shrink-0 basis-full sm:basis-[404px] max-lg:pl-2",
    treatment: "flex h-auto shrink-0 basis-full md:basis-[40%] lg:basis-[420px] max-lg:pl-2",
};

export default function AnswerCarouselBlock({
    answerItems,
    className,
    eventDataOnExpand,
    variant = "default",
    videoEvents,
    widget,
}: Props) {
    const {
        activeIndex,
        carouselRef,
        emblaApi,
        isInteracted,
        isVisible,
        setEmblaApi,
    } = useAnswerCarouselState();

    return (
        <div ref={carouselRef} className={cn("relative", className)}>
            <Carousel
                setApi={setEmblaApi}
                opts={{ align: "start", containScroll: variant === "treatment" ? false : undefined }}
                loop={false}
            >
                <CarouselContentVisible className="max-lg:-ml-2">
                    {answerItems.map((item, index) => (
                        <CarouselItem
                            key={item.question}
                            className={cardClasses[variant]}
                            onClick={() => emblaApi?.scrollTo(index)}
                        >
                            <Answer
                                {...item}
                                eventDataOnExpand={eventDataOnExpand}
                                isActive={index === activeIndex}
                                isInteracted={isInteracted}
                                isVisible={isVisible}
                                videoEvents={videoEvents}
                                widget={widget}
                            />
                        </CarouselItem>
                    ))}
                </CarouselContentVisible>
            </Carousel>
        </div>
    );
}
